<script setup lang="ts">
// Owned copy of shared-fe/components/layout/EmptyState.vue (scoped CSS).
defineProps<{ title: string; message?: string }>()
</script>

<template>
  <div class="empty">
    <h3>{{ title }}</h3>
    <p v-if="message" class="muted small">{{ message }}</p>
    <div v-if="$slots.default" class="action"><slot /></div>
  </div>
</template>

<style scoped>
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.25rem;
  border: 1px dashed var(--border);
  border-radius: var(--radius);
  padding: 2rem 1.5rem;
}
.action {
  margin-top: 1rem;
}
</style>
